export const ADMIN_ROUTE_NAME = {
  DASHBOARD: '',
  HOMEPAGE: 'homepage',
  SIGNIN: 'signin',
  STAFF_MANAGEMENT: 'staff-management',
  STAFF_DEPARTMENT_POSITION: 'staff-department-position',
  STAFF_TYPE_MANAGEMENT: 'staff-type-management',
  POSITION_MANAGEMENT: 'position-management',
  DEPARTMENT_MANAGEMENT: 'department-management',
  SCHEDULE: 'schedules',
  BOOKING: 'booking',
  LOCATION_MANAGEMENT: 'location-management',
  LOCATION: 'location',
  LOCATION_LIST: 'location-list',
  ATTENDANCE_MANAGEMENT: 'attendance-management',
  ATTENDANCE_MANAGEMENT_DETAIL: 'attendance-management/:employeeId',
  CONFIGURATION_MANAGEMENT: 'configuration-management',
  AFFILIATE_ACCOUNT: 'affiliate-account',
  LOGO: 'logo',
  WORKING_SCHEDULE: 'working-schedule',
  WORKING_HOURS: 'working-hours',
  OVERTIME_HOURS: 'over-time',
  CHOICE_SETTINGS: 'choice-settings',
  HOLIDAY: 'holiday',
  REQUEST_REVIEW: 'request-review',
  SETTING_MESSAGE: 'setting-message',
  APPLY_FOR_RECOGNITION: 'apply-for-recognition',
  TIMEKEEPING_CONFIRMATION: 'timekeeping-confirmation',
  OUT_OF_YEAR_MANAGEMENT: 'out-of-year-management',
  OUT_OF_YEAR_MANAGEMENT_DETAIL: 'out-of-year-management/:employeeId',
  ATTENDANCE_CONFIRMATION: 'attendance-confirmation',
  APPLICATION_LIST: 'application-list',
  TERMS_OF_USE_AND_POLICIES: 'terms-of-use-and-policies',
  PRIVACY_POLICY: 'privacy-policy',
  TERMS_OF_SERVICE: 'terms-of-service',
  ANNUAL_OVERTIME_DETAIL: 'annual-overtime-detail',
  EMPLOYEE_CONFIRM: 'employee-confirm',
  EMPLOYEE_APPLICAIION: 'employee-application',
  EMPLOYEE_ATTENDANCE: 'employee-attendance',
  ANNUAL_CONFIRMATION: 'annual-confirmation',
  TIMEKEEPING_REMINDER: 'timekeeping-reminder',
};
